<template>
  <footer class="footer">
    <div class="footer-content">
      <section class="mb-4 lg:mb-0">
        <p class="footer-title">
          Guaranteed safe checkout
        </p>

        <img
          src="@/assets/images/misc/safe-checkout.png"
          alt="Safe Checkout"
          class="safe-checkout"
        >
      </section>

      <section class="mb-4 lg:mb-0">
        <p class="footer-title">
          Used by incredible brands
        </p>

        <div class="footer-brands">
          <img
            class="footer-brand"
            src="@/assets/images/logos/cosmopolitan-magazine-logo.svg"
            alt="Cosmopolitan Magazine logo"
          >
          <img
            class="footer-brand"
            src="@/assets/images/logos/flo-logo.png"
            alt="For Love Of logo"
          >
          <img
            class="footer-brand"
            src="@/assets/images/logos/credabl-logo.svg"
            alt="Credabl logo"
          >
        </div>
      </section>

      <section class="">
        <p class="footer-title">
          Happy Shopify customers
        </p>

        <img
          src="@/assets/images/misc/rating.svg"
          alt="App Store Rating"
          class="rating"
        >
      </section>
    </div>
  </footer>
</template>

<script>
export default {
  name: "UpgradeFooter"
};
</script>

<style scoped>
.footer {
  @apply bg-grey-lightest py-8 px-6 text-center;
  box-shadow: inset 0px 3px 8px rgba(0, 0, 0, 0.08);

  @screen lg {
    padding: 55px 0;
  }
}

.footer-content {
  @screen lg {
    @apply flex justify-between items-stretch max-w-lg mx-auto;
  }

  @screen xl {
    @apply max-w-xl;
  }
}

.footer-title {
  @apply text-xs text-grey-dark mb-4;

  @screen lg {
    @apply mb-8;
  }
}

.safe-checkout {
  width: 280px;
}

.footer-brands {
  @apply flex justify-between max-w-xs mx-auto;

  @screen lg {
    margin-top: 55px;
  }
}

.footer-brand {
  height: 20px;
  width: auto;

  @screen lg {
    @apply mb-0 mx-2;
  }
}

.rating {
  width: 160px;

  @screen lg {
    margin-top: 13px;
  }
}
</style>
